// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.4.5_@swc+helpers@0.5.15__webpack@5.98.0_@swc+core@1.11.24_@sw_wm7ee5ic4mofrhisudwon4qpq4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.4.5_@swc+helpers@0.5.15__webpack@5.98.0_@swc+core@1.11.24_@sw_wm7ee5ic4mofrhisudwon4qpq4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.segment-explorer-content {
  font-size: var(--size-14);
  padding: 0 8px;
  width: 100%;
  height: 100%;
}

.segment-explorer-page-route-bar {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  background-color: var(--color-background-200);
  gap: 12px;
}

.segment-explorer-page-route-bar-path {
  font-size: var(--size-14);
  font-weight: 500;
  color: var(--color-gray-1000);
  font-family: var(--font-mono);
  white-space: nowrap;
  line-height: 20px;
}

.segment-explorer-item {
  margin: 4px 0;
  border-radius: 6px;
}

.segment-explorer-item:nth-child(even) {
  background-color: var(--color-background-200);
}
.segment-explorer-item-row {
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 4px;
}
.segment-explorer-item-row-main {
  display: flex;
  align-items: center;
  white-space: pre;
  cursor: default;
  color: var(--color-gray-1000);
}

.segment-explorer-children--intended {
  padding-left: 16px;
}

.segment-explorer-filename {
  display: inline-flex;
  width: 100%;
  align-items: center;
}

.segment-explorer-filename select {
  margin-left: auto;
}
.segment-explorer-filename--path {
  margin-right: 8px;
}
.segment-explorer-filename--path small {
  display: inline-block;
  width: 0;
  opacity: 0;
}
.segment-explorer-filename--name {
  color: var(--color-gray-800);
}

.segment-explorer-files {
  display: inline-flex;
  gap: 8px;
  margin-left: auto;
}

.segment-explorer-files + .segment-boundary-trigger {
  margin-left: 8px;
}

.segment-explorer-file-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  height: 20px;
  border-radius: 16px;
  line-height: 16px;
  font-size: var(--size-12);
  font-weight: 500;
  user-select: none;
  cursor: pointer;
  background-color: var(--color-gray-300);
  color: var(--color-gray-1000);
}
.segment-explorer-file-label-text {
  display: inline-flex;
  align-items: center;
}

.segment-explorer-file-label--overridden {
  background-color: var(--color-amber-300);
  color: var(--color-amber-900);
}

.segment-explorer-file-label .code-icon {
  opacity: 0;
  margin-left: 0;
  width: 0;
  transition: all 0.15s ease-in-out;
}
.segment-explorer-file-label:hover .code-icon {
  opacity: 1;
  width: 12px;
  margin-left: 4px;
}

.segment-explorer-file-label:hover {
  filter: brightness(0.95);
}

.segment-explorer-file-label--builtin {
  background-color: transparent;
  color: var(--color-gray-900);
  border: 1px dashed var(--color-gray-500);
  height: 24px;
  cursor: default;
}
.segment-explorer-file-label--builtin svg {
  margin-left: 4px;
  margin-right: -4px;
}

/* Footer styles */
.segment-explorer-footer {
  padding: 8px;
  border-top: 1px solid var(--color-gray-400);
  user-select: none;
}

.segment-explorer-footer-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 6px;
  background: var(--color-background-100);
  border: 1px solid var(--color-gray-400);
  border-radius: 6px;
  color: var(--color-gray-1000);
  font-size: var(--size-14);
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.segment-explorer-footer-button:hover:not(:disabled) {
  background: var(--color-gray-200);
}

.segment-explorer-footer-button--disabled {
  cursor: not-allowed;
}

.segment-explorer-footer-text {
  text-align: center;
}

.segment-explorer-footer-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: var(--color-amber-300);
  color: var(--color-amber-900);
  border-radius: 10px;
  font-size: var(--size-12);
  font-weight: 600;
  line-height: 1;
}

.segment-explorer-file-label-tooltip--sm {
  white-space: nowrap;
}

.segment-explorer-file-label-tooltip--lg {
  min-width: 200px;
}

.segment-explorer-suggestions {
  display: inline-flex;
  gap: 8px;
}

.segment-explorer-suggestions-tooltip {
  width: 200px;
}
`, "",{"version":3,"sources":["webpack://./src/next-devtools/dev-overlay/components/overview/segment-explorer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,uCAAuC;EACvC,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,QAAQ;EACR,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,wCAAwC;EACxC,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,uCAAuC;EACvC,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kCAAkC;EAClC,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd","sourcesContent":[".segment-explorer-content {\n  font-size: var(--size-14);\n  padding: 0 8px;\n  width: 100%;\n  height: 100%;\n}\n\n.segment-explorer-page-route-bar {\n  display: flex;\n  align-items: center;\n  padding: 14px 16px;\n  background-color: var(--color-background-200);\n  gap: 12px;\n}\n\n.segment-explorer-page-route-bar-path {\n  font-size: var(--size-14);\n  font-weight: 500;\n  color: var(--color-gray-1000);\n  font-family: var(--font-mono);\n  white-space: nowrap;\n  line-height: 20px;\n}\n\n.segment-explorer-item {\n  margin: 4px 0;\n  border-radius: 6px;\n}\n\n.segment-explorer-item:nth-child(even) {\n  background-color: var(--color-background-200);\n}\n.segment-explorer-item-row {\n  display: flex;\n  flex-direction: column;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-right: 4px;\n}\n.segment-explorer-item-row-main {\n  display: flex;\n  align-items: center;\n  white-space: pre;\n  cursor: default;\n  color: var(--color-gray-1000);\n}\n\n.segment-explorer-children--intended {\n  padding-left: 16px;\n}\n\n.segment-explorer-filename {\n  display: inline-flex;\n  width: 100%;\n  align-items: center;\n}\n\n.segment-explorer-filename select {\n  margin-left: auto;\n}\n.segment-explorer-filename--path {\n  margin-right: 8px;\n}\n.segment-explorer-filename--path small {\n  display: inline-block;\n  width: 0;\n  opacity: 0;\n}\n.segment-explorer-filename--name {\n  color: var(--color-gray-800);\n}\n\n.segment-explorer-files {\n  display: inline-flex;\n  gap: 8px;\n  margin-left: auto;\n}\n\n.segment-explorer-files + .segment-boundary-trigger {\n  margin-left: 8px;\n}\n\n.segment-explorer-file-label {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 6px;\n  height: 20px;\n  border-radius: 16px;\n  line-height: 16px;\n  font-size: var(--size-12);\n  font-weight: 500;\n  user-select: none;\n  cursor: pointer;\n  background-color: var(--color-gray-300);\n  color: var(--color-gray-1000);\n}\n.segment-explorer-file-label-text {\n  display: inline-flex;\n  align-items: center;\n}\n\n.segment-explorer-file-label--overridden {\n  background-color: var(--color-amber-300);\n  color: var(--color-amber-900);\n}\n\n.segment-explorer-file-label .code-icon {\n  opacity: 0;\n  margin-left: 0;\n  width: 0;\n  transition: all 0.15s ease-in-out;\n}\n.segment-explorer-file-label:hover .code-icon {\n  opacity: 1;\n  width: 12px;\n  margin-left: 4px;\n}\n\n.segment-explorer-file-label:hover {\n  filter: brightness(0.95);\n}\n\n.segment-explorer-file-label--builtin {\n  background-color: transparent;\n  color: var(--color-gray-900);\n  border: 1px dashed var(--color-gray-500);\n  height: 24px;\n  cursor: default;\n}\n.segment-explorer-file-label--builtin svg {\n  margin-left: 4px;\n  margin-right: -4px;\n}\n\n/* Footer styles */\n.segment-explorer-footer {\n  padding: 8px;\n  border-top: 1px solid var(--color-gray-400);\n  user-select: none;\n}\n\n.segment-explorer-footer-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 6px;\n  background: var(--color-background-100);\n  border: 1px solid var(--color-gray-400);\n  border-radius: 6px;\n  color: var(--color-gray-1000);\n  font-size: var(--size-14);\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.segment-explorer-footer-button:hover:not(:disabled) {\n  background: var(--color-gray-200);\n}\n\n.segment-explorer-footer-button--disabled {\n  cursor: not-allowed;\n}\n\n.segment-explorer-footer-text {\n  text-align: center;\n}\n\n.segment-explorer-footer-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  height: 20px;\n  padding: 0 6px;\n  background: var(--color-amber-300);\n  color: var(--color-amber-900);\n  border-radius: 10px;\n  font-size: var(--size-12);\n  font-weight: 600;\n  line-height: 1;\n}\n\n.segment-explorer-file-label-tooltip--sm {\n  white-space: nowrap;\n}\n\n.segment-explorer-file-label-tooltip--lg {\n  min-width: 200px;\n}\n\n.segment-explorer-suggestions {\n  display: inline-flex;\n  gap: 8px;\n}\n\n.segment-explorer-suggestions-tooltip {\n  width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
